import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail-card" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }

import VerticalGap from '@shell/components/Resource/Detail/Card/VerticalGap.vue';

export interface CardProps {
    title?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "heading", {}, () => [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ])
        ])
      ]),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _renderSlot(_ctx.$slots, "heading-action")
    ]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(VerticalGap),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})